export default "__VITE_ASSET__5pOk74oE__"